import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import localeRu from 'air-datepicker/locale/ru';
import localeAz from './air-datepicker-locale/az';
// import 'air-datepicker/air-datepicker.css';
import { debounce } from './debounce';


export function datepicker() {

    let dateFields = document.querySelectorAll('[data-date]');
    const tomorrowDate = new Date();
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    tomorrowDate.setHours(0, 0, 0, 0);
    const localesDatepicker = {
        'en': localeEn,
        'ru-RU': localeRu,
        'az': localeAz
    };
    const htmlLang = document.documentElement.lang || 'en';
    const selectedLocaleDatepicker = localesDatepicker[htmlLang] || localeEn;
    let initialOptions = {
        position: 'top right',
        isMobile: isMobile(),
        autoClose: isMobile(),
        locale: selectedLocaleDatepicker,
    };
    let ticketInitialOptions = {
        position: 'top right',
        isMobile: isMobile(),
        autoClose: isMobile(),
        selectedDates: [tomorrowDate],
        locale: selectedLocaleDatepicker,
        minDate: tomorrowDate,
    };

    let pickers = [];

    dateFields.forEach((field) => {
        // https://air-datepicker.com/ru/docs
        let options = field.getAttribute('id')==='ticket_datetime'
            ? ticketInitialOptions
            : initialOptions;
        if(field.hasAttribute('data-maxdate')) {
            options.maxDate = new Date(field.getAttribute('data-maxdate'));
        }
        if(field.hasAttribute('data-mindate')) {
            options.minDate = new Date(field.getAttribute('data-mindate'));
        }
        let picker = new AirDatepicker(
            field,
            options
        );

        if (picker.$el.value != "") picker.selectDate(new Date(picker.$el.value));

        pickers.push(picker);
    })

    function isMobile() {
        if (window.innerWidth >= 1200) {
            return false;
        } else {
            return true;
        }
    }

    function updatePicker() {
        if (isMobile()) {
            pickers.forEach(picker => {
                picker.update({
                    isMobile: true,
                    autoClose: true,
                    selectedDates: (picker.$el.value != "") ? [new Date(picker.$el.value)] : [tomorrowDate]
                });
            })

        } else {
            pickers.forEach(picker => {
                picker.update({
                    isMobile: false,
                    autoClose: false,
                    selectedDates: (picker.$el.value != "") ? [new Date(picker.$el.value)] : [tomorrowDate]
                });
            })
        }
    }

    let debouncedUpdate = debounce(updatePicker, 500);

    window.addEventListener('resize', evt => debouncedUpdate());

}
